import * as cmOnOffTypes from '../../consts/communicationLayer/cmOnOffTypes';
import * as autoStartModeTypes from '../../consts/iot/autoStartModeTypes';
import * as responsiveDrawModeTypes from '../../consts/iot/responsiveDrawModeTypes';
import * as yapResponsiveDrawModeTypes from '../../consts/yap/responsiveDrawModeTypes';
import * as yapUpdateSettingsTypes from '../../consts/yap/yapUpdateSettingsTypes';
import {makeSelectIotDeviceData} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import iotDeviceFWUStateService from '../iotDevice/iotDeviceFWUStateService';
import yapFWUService from '../yap/yapFWUService';
import gamClientService from './gamClientService';

const publishConnectionCareMessage = () => {};

const publishVibrationAlarmMessage = () => {};

const publishStopVibrationAlarmMessage = () => {};

const publishCheckFirmwareMessage = async (fwuTarget) => {
    iotDeviceFWUStateService.setIotTargetFwuStateOnFwuCheckRequest(fwuTarget);

    const result = await yapFWUService.getFirmwareAvailability(fwuTarget);

    if (!result) {
        iotDeviceFWUStateService.setIotTargetFwuStateOnFwuCheckRequest(fwuTarget, false);
    }
    return result;
};

const publishInitiateUpdateFirmwareMessage = async (fwuTarget) => {
    await yapFWUService.updateFirmware(fwuTarget, publishCheckFirmwareMessage);
};

const publishGetLedSettingsMessage = () => {};

const publishGetVibrationSettingsMessage = () => publishVibrationSettingsMessage();

const publishGetAutoStartSettingsMessage = () => publishAutoStartSettingsMessage();

const publishGetGestureSettingsMessage = () => publishGesturetSettingsMessage();

const publishGetResponsiveDrawSettingsMessage = () => publishResponsiveDrawSettingsMessage();

const publishGetVapeCloudSizeSettingsMessage = () => publishVapeCloudSizeSettingsMessage();

const publishGetCountdownSettingsMessage = () => publishCountdownSettingsMessage();

const publishSetLedSettingsMessage = async (mode, isDeviceLedModeEnabled, isHolderLedModeEnabled) => {
    if (!mode) return;

    const message = {
        settingName: yapUpdateSettingsTypes.LED_INTENSITY,
        newValue: {intensity: mode},
    };
    const iotDevice = makeSelectIotDeviceData()(getState());
    const {holder, device} = iotDevice?.ledData || {};
    const holderLed = holder?.intensity;
    const deviceLed = device?.intensity;

    if (isDeviceLedModeEnabled && mode !== deviceLed) {
        await gamClientService.updateGamSettings(message);
    }

    if (isHolderLedModeEnabled && mode !== holderLed) {
        await gamClientService.updateGamSettings(message, true);
    }
};

const publishSetResponsiveDrawSettingsMessage = (mode) => publishResponsiveDrawSettingsMessage(mode);

const publishSetVapeCloudSizeSettingsMessage = (mode) => publishVapeCloudSizeSettingsMessage(mode);

const publishSetAutoStartSettingsMessage = async (data) => {
    const autostart_feature_state = data?.holder?.autostart_feature_state;

    if (!autostart_feature_state) return;

    const onOffMessage =
        autostart_feature_state === autoStartModeTypes.AUTO_START_STATE_ENABLED ? cmOnOffTypes.ON : cmOnOffTypes.OFF;
    const message = {
        settingName: yapUpdateSettingsTypes.AUTO_START_HEATING,
        newValue: {featureState: onOffMessage},
    };

    await gamClientService.updateGamSettings(message, true);
};

const publishSetGestureSettingsMessage = async (data) => {
    const {status_gesture_pickup_enabled, status_gesture_double_tap_enabled} = data?.holder || {};

    let message = null;
    const getGestureState = (settingName, onOffMessage) => {
        return {settingName, newValue: {gestureState: onOffMessage}};
    };

    if (status_gesture_pickup_enabled !== undefined) {
        const onOffMessage = status_gesture_pickup_enabled ? cmOnOffTypes.ON : cmOnOffTypes.OFF;

        message = getGestureState(yapUpdateSettingsTypes.LIFT_UP_GESTURE, onOffMessage);
    }

    if (status_gesture_double_tap_enabled !== undefined) {
        const onOffMessage = status_gesture_double_tap_enabled ? cmOnOffTypes.ON : cmOnOffTypes.OFF;

        message = getGestureState(yapUpdateSettingsTypes.DOUBLE_TAP_GESTURE, onOffMessage);
    }

    if (message) {
        await gamClientService.updateGamSettings(message, true);
    }
};

const publishSetCountdownSettingsMessage = () => publishCountdownSettingsMessage();

const publishResetVibrationSettingsMessage = () => publishVibrationSettingsMessage();

const publishResponsiveDrawSettingsMessage = (mode) => {
    const message = {
        settingName: yapUpdateSettingsTypes.RESPONSIVE_DRAW_PROFILE,
    };

    if (mode) {
        if (mode === responsiveDrawModeTypes.VIVACE) {
            mode = yapResponsiveDrawModeTypes.ALLEGRO;
        } else if (mode === responsiveDrawModeTypes.STACCATO) {
            mode = yapResponsiveDrawModeTypes.VIVALDI;
        }
        message.newValue = {hapticPattern: mode};
    }

    return gamClientService.updateGamSettings(message);
};

const publishVapeCloudSizeSettingsMessage = (mode) => {
    const message = {
        settingName: yapUpdateSettingsTypes.VAPE_CLOUD_SIZE,
    };

    if (mode) {
        message.newValue = {heatingProfile: mode};
    }

    return gamClientService.updateGamSettings(message);
};

const publishSessionProfilingSettingsMessage = async (puffData) => {
    const {puffNumber, puffingTime} = puffData || {};

    const message = {
        settingName: yapUpdateSettingsTypes.SESSION_PROFILING,
        newValue: {puffNumber, puffingTime},
    };

    await gamClientService.updateGamSettings(message);
};

const publishVibrationSettingsMessage = () => {};

const publishAutoStartSettingsMessage = () => {};

const publishGesturetSettingsMessage = () => {};

const publishCleaningMessage = () => {};

const publishCleaningCheckMessage = () => {};

const publishCountdownSettingsMessage = () => {};

const publishDeviceRestartMessage = async (isHolder) => {
    return gamClientService.resetMyDevice(isHolder);
};

const publishBatteryInfoCharacteristicUsbMessage = () => {};

export default {
    publishCheckFirmwareMessage,
    publishCleaningMessage,
    publishConnectionCareMessage,
    publishGetLedSettingsMessage,
    publishGetVibrationSettingsMessage,
    publishGetAutoStartSettingsMessage,
    publishGetGestureSettingsMessage,
    publishGetCountdownSettingsMessage,
    publishCleaningCheckMessage,
    publishResetVibrationSettingsMessage,
    publishSetLedSettingsMessage,
    publishSetAutoStartSettingsMessage,
    publishSetGestureSettingsMessage,
    publishSetCountdownSettingsMessage,
    publishInitiateUpdateFirmwareMessage,
    publishStopVibrationAlarmMessage,
    publishVibrationAlarmMessage,
    publishGetResponsiveDrawSettingsMessage,
    publishSetResponsiveDrawSettingsMessage,
    publishGetVapeCloudSizeSettingsMessage,
    publishSessionProfilingSettingsMessage,
    publishSetVapeCloudSizeSettingsMessage,
    publishDeviceRestartMessage,
    publishBatteryInfoCharacteristicUsbMessage,
};
